
<div class="row">
  <div class="col-lg-6 col-md-12">
    <!-- CARD TABLE: VISUALIZACION DE FOLIOS DISPONIBLES -->
    <app-table-view-folios></app-table-view-folios>
  </div>
</div>

<!-- Cabecera de botones -->
<!-- <div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="wizardConfig.show()"
        size="sm"
        mdbWavesEffect
      >
        Wizard
      </button>
    </div>
  </div>

</div> -->



<!-- MODAL wizardConfig -->
<!-- <div 
  mdbModal
  style="overflow-y: auto;"
  #wizardConfig="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true, show: true }"
>

  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Bienvenidos!</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="wizardConfig.hide()"><span aria-hidden="true">×</span></button>
      </div>
      <div class="modal-body pt-0">
          <mdb-stepper #stepper [vertical]="true" class="mt-0">
            <mdb-step name="Datos de usuario" label="Rellena los campos para continuar" [stepForm]="firstFormGroup">
              <form [formGroup]="firstFormGroup">
                <div class="md-form">
                  <input type="text" class="form-control" mdbInput mdbValidate formControlName="rut_user">
                  <label for="">RUT</label>
                  <mdb-error *ngIf="rut_user.invalid && (rut_user.dirty || rut_user.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="rut_user.valid && (rut_user.dirty || rut_user.touched)">Ok!</mdb-success>
                </div>
                <div class="md-form">
                  <input type="text" class="form-control" mdbInput mdbValidate formControlName="nom_user">
                  <label for="">Usuario</label>
                  <mdb-error *ngIf="nom_user.invalid && (nom_user.dirty || nom_user.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="nom_user.valid && (nom_user.dirty || nom_user.touched)">Ok!</mdb-success>
                </div>
                <div class="md-form">
                  <input type="text" class="form-control" mdbInput mdbValidate formControlName="nom_ape">
                  <label for="">Nombre y Apellido</label>
                  <mdb-error *ngIf="nom_ape.invalid && (nom_ape.dirty || nom_ape.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="nom_ape.valid && (nom_ape.dirty || nom_ape.touched)">Ok!</mdb-success>
                </div>
                <div class="md-form">
                  <input type="text" class="form-control" mdbInput mdbValidate formControlName="email">
                  <label for="">Email</label>
                  <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="email.valid && (email.dirty || email.touched)">Ok!</mdb-success>
                </div>
                <div class="md-form">
                  <input type="password" class="form-control" mdbInput mdbValidate formControlName="pass1">
                  <label for="">Contraseña</label>
                  <mdb-error *ngIf="pass1.invalid && (pass1.dirty || pass1.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="pass1.valid && (pass1.dirty || pass1.touched)">Ok!</mdb-success>
                </div>
                <div class="md-form">
                  <input type="password" class="form-control" mdbInput mdbValidate formControlName="pass2">
                  <label for="">Confirmar contaseña</label>
                  <mdb-error *ngIf="pass2.invalid && (pass2.dirty || pass2.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="pass2.valid && (pass2.dirty || pass2.touched)">Ok!</mdb-success>
                </div>
              </form>
              <button mdbBtn size="sm" color="primary" (click)="stepper.next()">CONTINUAR</button>
            </mdb-step>
            <mdb-step name="Datos de empresa" [stepForm]="secondFormGroup">
              <form [formGroup]="secondFormGroup">
                <div class="md-form">
                  <input type="text" class="form-control" mdbInput mdbValidate formControlName="rut_empr">
                  <label for="">RUT</label>
                  <mdb-error *ngIf="rut_empr.invalid && (rut_empr.dirty || rut_empr.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="rut_empr.valid && (rut_empr.dirty || rut_empr.touched)">Ok!</mdb-success>
                </div>
                <div class="md-form">
                  <input type="text" class="form-control" mdbInput mdbValidate formControlName="nom_empr">
                  <label for="">Nombre</label>
                  <mdb-error *ngIf="nom_empr.invalid && (nom_empr.dirty || nom_empr.touched)">Dato inválido!</mdb-error>
                  <mdb-success *ngIf="nom_empr.valid && (nom_empr.dirty || nom_empr.touched)">Ok!</mdb-success>
                </div>
              </form>
              <button mdbBtn size="sm" color="primary" (click)="stepper.next()">CONTINUAR</button>
              <button mdbBtn size="sm" color="secondary" (click)="stepper.previous()">ANTERIOR</button>
            </mdb-step>
            <mdb-step name="Crear la configuración!">
              <div class="step-actions">
                <button mdbBtn  size="sm" color="primary" (click)="wizardConfig.hide()">Guardar</button>
              </div>
            </mdb-step>
        </mdb-stepper>

      </div>
    </div>
  </div>

</div> -->



<!-- MODAL cambiarPass -->
<div *ngIf="flag_cambio"
  mdbModal
  #cambiarPass="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true, show: true }"
>
<form [formGroup]="formulario" (ngSubmit)="cambioClave(); cambiarPass.hide();">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Cambiar contraseña</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cambiarPass.hide()"><span aria-hidden="true">×</span></button>
      </div>
      <div class="modal-body p-5">
          <p>Antes de continuar debes cambiar la contraseña.</p>
          <div class="row">
            <div class="col" style="max-width: 100px;"><h5>Empresa:</h5></div>
            <div class="col">
              <h5 class="grey-blue-text"><strong>{{nombre_empresa}}</strong></h5>
            </div>
          </div>
          <div class="md-form">
            <mdb-icon fas icon="key" class="prefix grey-text"></mdb-icon>
            <input formControlName="password" mdbInput value="" type="password" id="npassword" class="form-control" #npassword/>
            <label for="npassword">Contraseña</label>
            <div *ngIf="formulario.get('password').invalid && (formulario.get('password').dirty || formulario.get('password').touched)"><mdb-error *ngIf="formulario.get('password').hasError('required')">La Contraseña es requerido.</mdb-error>
              <mdb-error *ngIf="formulario.get('password').hasError('maxlength')">La Contraseña no puede superar los 15 caracteres.</mdb-error>
              <mdb-error *ngIf="formulario.get('password').hasError('minlength')">La Contraseña tener como mínimo 5 caracteres.</mdb-error>
            </div>
          </div>
          <div class="md-form">
            <mdb-icon fas icon="key" class="prefix grey-text"></mdb-icon>
            <input formControlName="confirmarpass" mdbInput value="" type="password" id="cpassword" class="form-control" #cpassword/>
            <label for="cpassword">Confirmar contraseña</label>
            <div *ngIf="formulario.get('confirmarpass').invalid && (formulario.get('confirmarpass').dirty || formulario.get('confirmarpass').touched)">
              <mdb-error *ngIf="formulario.get('confirmarpass').hasError('required')">La Confirmacion de Contraseña es requerido.</mdb-error>
              <mdb-error *ngIf="formulario.get('confirmarpass').hasError('maxlength')">La Confirmacion de Contraseña no puede superar los 15 caracteres.</mdb-error>
              <mdb-error *ngIf="formulario.get('confirmarpass').hasError('minlength')">La Confirmacion de Contraseña debe tener como mínimo 5 caracteres.</mdb-error>
              <mdb-error *ngIf="formulario.get('confirmarpass').hasError('mismatch')">La Contraseña no coincide.</mdb-error>
            </div>
          </div>
      </div>
      <div class="modal-footer justify-content-center">
        <button mdbBtn type="submit" color="secondary" class="mb-2" mdbWavesEffect [disabled]="formulario.invalid" >Continuar</button>
      </div>
    </div>
  </div>
</form>
</div>
